<ui-title [title]="'Settings'"></ui-title>

<ui-popup [(isHidden)]="alert.hidden" [text]="alert.title" [type]="alert.type"></ui-popup>

<mat-accordion>
	<mat-expansion-panel>
		<mat-expansion-panel-header>
			<mat-panel-title>
				Report Schedule
			</mat-panel-title>
			<mat-panel-description>
			</mat-panel-description>
		</mat-expansion-panel-header>


		<ui-loading [loading]="schedules.saving||schedules.loading"
					[loadingText]="schedules.loading?'loading':'saving'"></ui-loading>

		<div class="alert alert-danger" *ngIf="schedules.errorLoad">Sorry, cannot load the schedule, please reload the
			page to try again
		</div>

		<div class="row" *ngIf="!schedules.loading">
			<div class="col-lg-4">

				<ui-table [filters]="false" [chunker]="schedules.chunker" (chunked)="schedules.chunkedData = $event"
						  [headers]="schedules.tableHeaders" #table>
					<tr *ngFor="let d of schedules.chunkedData">
						<td style="line-height: 25px">{{d.ReportType}}</td>
						<td style="line-height: 25px">{{d.Date|date}}</td>
						<td style="line-height: 25px">
							<button type="button" class="btn btn-danger btn-sm" style=" width:100%;  margin-top: -3px;
							padding-top: 8px;" (click)="schedules_delete(d.Id)" *ngIf="!isAuditor && schedules_isFutureDate(d.Date)">unschedule
							</button>
						</td>
					</tr>
				</ui-table>


			</div>
			<div class="col-lg-4">
				<p class="alert alert-warning small">
					QAR Report is run on the morning of the selected date.<br>Batches are created on the night before
				</p>
				<p class="alert alert-warning small">
					Schedule list all scheduled in the future <br/>or in the last 7 days (since {{schedules.sevenDaysAgo|date}})

				</p>

				<form>
					<div class="form-group row">
						<label class="col-lg-3 col-form-label">
							Report Type
						</label>
						<div class="col-lg-9">

							<select class="form-control" style="width:200px" name="reporttype"
									[(ngModel)]="schedules.reportType">
								<option value=""></option>
								<option value="QAR">QAR</option>
								<option value="SOD">SOD</option>
								<option value="AUTHORITY_LIMIT">Authority Limit</option>
								<option value="Sequel_Claims_TC">Sequel Claims TC users</option>
							</select>

						</div>
					</div>
					<div class="form-group row">
						<label class="col-lg-3 col-form-label">
							Date
						</label>
						<div class="col-lg-9">

							<input class="form-control" style="width:200px" type="date" name="scheduledate"
								   [(ngModel)]="schedules.date">


						</div>
					</div>

					<button mat-button class="btn-primary float-right" (click)="schedules_add()">
						Schedule
					</button>
				</form>

			</div>

		</div>

	</mat-expansion-panel>

	<mat-expansion-panel>
		<mat-expansion-panel-header>
			<mat-panel-title>
				Report Chasing Plan
			</mat-panel-title>
			<mat-panel-description>
			</mat-panel-description>
		</mat-expansion-panel-header>


		<div class="alert alert-danger" *ngIf="chasing.errorLoad">Sorry, cannot load the report chasing plan, please
			reload the page to try again
		</div>
		<ui-loading [loading]="chasing.loading||chasing.saving" [loadingText]="chasing.loading?'loading':'saving'">
		</ui-loading>
		<form [hidden]="chasing.loading || chasing.saving">
			<table class="table">
				<tr>
					<th>Required?</th>
					<th>Action</th>
					<th>When</th>
					<th>To</th>
				</tr>
				<tr>
					<td>
						<mat-checkbox color="primary" [(ngModel)]="chasing.data.reminder1Active"
									  [checked]="chasing.data.reminder1Active" name="reminder1Active"></mat-checkbox>
					</td>
					<td>1st Email Chaser</td>
					<td>
						<input class="form-control" name="raxd1" style="width: 40px;    display: inline-block;"
							   (change)="input_allowOnlyNumberChange($event)" (keydown)="input_allowOnlyNumber($event)"
							   [(ngModel)]="chasing.data.reminder1AfterXDays"/> days after report
					</td>
					<td>
						Approver
					</td>
				</tr>
				<tr>
					<td>
						<mat-checkbox color="primary" [(ngModel)]="chasing.data.reminder2Active"
									  [checked]="chasing.data.reminder2Active" name="reminder2Active"></mat-checkbox>
					</td>
					<td>2nd Email Chaser</td>
					<td>
						<input class="form-control" name="raxd2" style="width: 40px;    display: inline-block;"
							   (change)="input_allowOnlyNumberChange($event)" (keydown)="input_allowOnlyNumber($event)"
							   [(ngModel)]="chasing.data.reminder2AfterXDays"/> days after 1st email chaser
					</td>
					<td>
						Approver
					</td>
				</tr>
				<tr>
					<td>
						<mat-checkbox color="primary" [(ngModel)]="chasing.data.reminder3Active"
									  [checked]="chasing.data.reminder3Active" name="reminder3Active"></mat-checkbox>
					</td>
					<td>Escalation Email</td>
					<td>
						<input class="form-control" name="raxd3" style="width: 40px;    display: inline-block;"
							   (change)="input_allowOnlyNumberChange($event)" (keydown)="input_allowOnlyNumber($event)"
							   [(ngModel)]="chasing.data.reminder3AfterXDays"/> days after 2nd email chaser
					</td>
					<td>

						<input placeholder="Email Address" class="form-control" [(ngModel)]="chasing.data.reminderEmail"
							   name="reminderEmail"/>
					</td>
				</tr>
			</table>
			<button mat-button class="btn-primary float-right" (click)="chasing_save()">
				Save
			</button>
		</form>


	</mat-expansion-panel>

	<mat-expansion-panel *ngIf="!isAuditor">
		<mat-expansion-panel-header>
			<mat-panel-title>
				Rejection Reasons Notification - Email Distribution
			</mat-panel-title>
			<mat-panel-description>
			</mat-panel-description>
		</mat-expansion-panel-header>

		<div class="alert alert-danger" *ngIf="rejection.errorLoad">Sorry, cannot load the report chasing plan, please
			reload the page to try again
		</div>
		<ui-loading [loading]="rejection.loading||rejection.saving"
					[loadingText]="rejection.loading?'loading':'saving'"></ui-loading>

		<form [hidden]="rejection.saving || rejection.loading">

			<div class="col-lg-6">
				<ui-input-email-list [api]="api" [name]="'emails'" [(ngModel)]="rejection.data.emails" (onChange)="rejection_save()"></ui-input-email-list>
			</div>
		</form>


	</mat-expansion-panel>

	<mat-expansion-panel *ngIf="!isAuditor">
		<mat-expansion-panel-header>
			<mat-panel-title>
				SOD Clash Report - Email Distribution
			</mat-panel-title>
			<mat-panel-description>
			</mat-panel-description>
		</mat-expansion-panel-header>

		<div class="alert alert-danger" *ngIf="sodClash.errorLoad">Sorry, cannot load, please reload the page to try
			again
		</div>
		<ui-loading [loading]="sodClash.loading||sodClash.saving" [loadingText]="sodClash.loading?'loading':'saving'">
		</ui-loading>

		<form [hidden]="sodClash.saving || sodClash.loading">

			<div class="col-lg-6">
				<ui-input-email-list [api]="api" [name]="'emails2'" [(ngModel)]="sodClash.data.emails" (onChange)="sodClash_save()"></ui-input-email-list>
			</div>
		</form>


	</mat-expansion-panel>


	<mat-expansion-panel *ngIf="!isAuditor">
		<mat-expansion-panel-header>
			<mat-panel-title>
				Others
			</mat-panel-title>
			<mat-panel-description>
			</mat-panel-description>
		</mat-expansion-panel-header>

		<div class="alert alert-danger" *ngIf="others.errorLoading">Sorry, cannot load, please reload the page to try
			again
		</div>
		<ui-loading [loading]="others.loading||others.saving" [loadingText]="others.loading?'loading':'saving'">
		</ui-loading>

		<form [hidden]="others.saving || others.loading">
			<div class="row mb-3" *ngFor="let kv of others.data|kv">
				<label class="col-lg-4 col-form-label" [innerHTML]="helper_camelCaseToHuman(kv.key)">
				</label>
				<div class="col-lg-4">
					<input type="text" [(ngModel)]="others.data[kv.key]" [name]="kv.key" class="form-control"/>
				</div>
			</div>
			<button mat-button class="btn-primary float-right" (click)="others_save()">
				Save
			</button>
		</form>


	</mat-expansion-panel>

</mat-accordion>
